import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class EditorSaveService {
  private saveSubject = new Subject<{
    field: string;
    value: string;
  }>();

  save$ = this.saveSubject.asObservable();

  requestSave(field: string, value: string) {
    this.saveSubject.next({ field, value });
  }
}

